export interface ArticleData {
  id: number;
  title: string;
  subtitle: string;
  category: string;
  tags: string[];
  year: string;
  region: string;
  language: string;
  duration: string;
  rating: string;
  director: string;
  cast: string[];
  synopsis: string;
  highlights: string[];
  image: string;
  gallery: string[];
  updateInfo: string;
  episodeInfo: string;
  relatedIds: number[];
}

const articleMap: Record<number, ArticleData> = {
  1: {
    id: 1, title: '速度与激情10', subtitle: '2026年最燃动作巨制，极速狂飙震撼回归',
    category: '动作 / 冒险 / 犯罪', tags: ['动作', '冒险', '犯罪', '飙车'],
    year: '2026', region: '美国', language: '英语', duration: '142分钟', rating: '8.5',
    director: '路易斯·莱特里尔',
    cast: ['范·迪塞尔', '杰森·斯坦森', '查理兹·塞隆', '约翰·塞纳'],
    synopsis: '范·迪塞尔饰演的唐老大为了守护家人再度出山，这次他面对的是一个来自过去的强大敌人——但丁。但丁是当年唐老大在巴西里约热内卢干掉的大毒枭的儿子，他策划了12年的复仇计划，发誓要让唐老大失去所有最在乎的东西。从罗马到里约，从伦敦到南极，一场横跨全球的速度之战就此展开。家族成员们必须再次团结起来，因为这一次，他们面对的不仅是速度的较量，更是生死的抉择。',
    highlights: ['全球取景：罗马、伦敦、里约、南极四大场景实拍', '最强反派：杰森·莫玛饰演的但丁堪称系列最佳反派', '惊天特技：实拍赛车飞跃峡谷创系列危险纪录', '家族情谊：范·迪塞尔与保罗·沃克的跨时空致敬'],
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20with%20fast%20cars%20racing%20on%20city%20streets%2C%20warm%20orange%20and%20golden%20sunset%20lighting%2C%20action%20packed%20atmosphere%2C%20dramatic%20composition%2C%20Hollywood%20blockbuster%20aesthetic%2C%20dark%20rich%20background&width=800&height=450&seq=article-01-hd&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Action%20movie%20car%20chase%20scene%20on%20highway%2C%20warm%20sunset%20golden%20lighting%2C%20explosions%20and%20speed%2C%20cinematic%20atmosphere%2C%20Hollywood%20blockbuster%20style%2C%20dark%20background%20elements&width=800&height=450&seq=article-01-a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Movie%20scene%20with%20characters%20standing%20together%20in%20dramatic%20lighting%2C%20warm%20amber%20tones%2C%20cinematic%20portrait%20style%2C%20dark%20atmospheric%20background%2C%20professional%20film%20aesthetic&width=800&height=450&seq=article-01-b&orientation=landscape',
    ],
    updateInfo: '2026年7月15日上线', episodeInfo: 'HD 1080P 蓝光版',
    relatedIds: [4, 8, 105],
  },
  2: {
    id: 2, title: '流浪地球3', subtitle: '中国科幻史诗终章，人类文明的最后抉择',
    category: '科幻 / 灾难 / 冒险', tags: ['科幻', '灾难', '冒险', '太空'],
    year: '2026', region: '中国大陆', language: '普通话', duration: '168分钟', rating: '9.1',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢'],
    synopsis: '人类在地球流浪2500年的旅程中遭遇了前所未有的危机。当太阳系的外缘出现未知文明信号时，联合政府内部出现了严重分歧。刘培强中校的儿子刘启成长为新一代的领航员，他必须在拯救地球和与未知文明沟通之间做出选择。与此同时，地球发动机出现未知故障，人类的生存再次受到威胁。在这部系列终章中，所有谜团都将揭晓，人类文明的命运也将迎来最终答案。',
    highlights: ['视效升级：全片2000+特效镜头刷新国产科幻纪录', '情感内核：吴京父子情与人类命运的双线叙事', '哲学深度：探讨文明存续与人性的终极命题', '原班人马：郭帆导演携核心阵容打造史诗结局'],
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20scene%20with%20massive%20spaceship%20and%20planets%20in%20deep%20space%2C%20warm%20golden%20nebula%20lighting%2C%20cinematic%20atmosphere%2C%20grand%20scale%2C%20dark%20cosmic%20background%2C%20professional%20film%20aesthetic&width=800&height=450&seq=article-02-hd&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20scene%20with%20futuristic%20city%20and%20spaceships%2C%20warm%20orange%20glow%2C%20cinematic%20lighting%2C%20dark%20space%20background%2C%20professional%20film%20aesthetic&width=800&height=450&seq=article-02-a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20scene%20with%20astronaut%20looking%20at%20Earth%20from%20space%2C%20warm%20golden%20sunlight%2C%20cinematic%20aesthetic%2C%20dark%20cosmic%20background%2C%20professional%20film%20composition&width=800&height=450&seq=article-02-b&orientation=landscape',
    ],
    updateInfo: '2026年8月1日上线', episodeInfo: 'HD 4K 杜比全景声',
    relatedIds: [6, 12, 103],
  },
  3: {
    id: 3, title: '哪吒之魔童闹海', subtitle: '国漫之光归来，我命由我不由天',
    category: '动画 / 奇幻 / 动作', tags: ['动画', '奇幻', '动作', '神话'],
    year: '2026', region: '中国大陆', language: '普通话', duration: '130分钟', rating: '9.3',
    director: '饺子',
    cast: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩'],
    synopsis: '天劫之后，哪吒和敖丙虽保住了魂魄，但肉身危在旦夕。太乙真人打算用七色宝莲为二人重塑肉身，然而在重塑过程中却遭遇了前所未有的困难。申公豹放出被囚禁的四海龙王，一场席卷天地的大战一触即发。哪吒面对命运的不公，再次喊出"我命由我不由天"的宣言，与敖丙携手对抗天庭的宿命。在友情、亲情与责任之间，哪吒将做出怎样的抉择？',
    highlights: ['技术突破：画面精细度较前作提升300%', '故事升级：哪吒与敖丙的命运羁绊深化', '神级特效：四海龙王齐出的终极大战场景', '情感共鸣：中国式家庭情感的现代化表达'],
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20animated%20film%20scene%20with%20dragon%20and%20fire%20elements%2C%20warm%20crimson%20and%20golden%20lighting%2C%20cinematic%20composition%2C%20dark%20atmospheric%20background%2C%20professional%20animation%20aesthetic&width=800&height=450&seq=article-03-hd&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20battle%20scene%20with%20fire%20and%20water%20elements%2C%20warm%20crimson%20golden%20lighting%2C%20cinematic%20composition%2C%20dark%20background%2C%20professional%20anime%20style&width=800&height=450&seq=article-03-a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20character%20standing%20on%20cloud%2C%20warm%20golden%20sunset%20lighting%2C%20mythological%20atmosphere%2C%20dark%20rich%20background%2C%20professional%20animation%20aesthetic&width=800&height=450&seq=article-03-b&orientation=landscape',
    ],
    updateInfo: '2026年6月1日上线', episodeInfo: 'HD 4K 杜比视界',
    relatedIds: [4, 5, 401],
  },
  10: {
    id: 10, title: '庆余年3', subtitle: '京都风云再起，权谋与江湖的巅峰对决',
    category: '古装 / 权谋 / 剧情', tags: ['古装', '权谋', '剧情', '武侠'],
    year: '2026', region: '中国大陆', language: '普通话', duration: '45分钟/集', rating: '9.0',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    synopsis: '在庆余年第三季中，范闲的身世之谜终于揭晓。作为庆帝之子，他不得不在皇权斗争与个人恩怨之间做出抉择。京都朝堂风云变幻，各方势力明争暗斗。范闲凭借现代人的智慧和超群的武艺，在权谋漩涡中步步为营。与此同时，他对叶轻眉留下的秘密有了更深的了解，一个足以颠覆整个世界的真相正在浮出水面。',
    highlights: ['原班人马：张若昀、李沁、陈道明等全员回归', '剧情升级：朝堂权谋与江湖恩怨双重交织', '制作精良：服化道全面升级，场景宏大壮观', '神仙阵容：新角色加盟，群像戏更加丰富'],
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20scene%20in%20ancient%20palace%2C%20warm%20golden%20and%20amber%20lighting%2C%20cinematic%20composition%2C%20dark%20rich%20background%2C%20professional%20TV%20series%20aesthetic&width=800&height=450&seq=article-10-hd&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Chinese%20palace%20throne%20room%20scene%20with%20dramatic%20lighting%2C%20warm%20golden%20tones%2C%20ancient%20Chinese%20aesthetic%2C%20dark%20rich%20background%2C%20professional%20film%20composition&width=800&height=450&seq=article-10-a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20scene%20in%20ancient%20courtyard%2C%20warm%20amber%20sunset%20lighting%2C%20cinematic%20atmosphere%2C%20dark%20background%2C%20professional%20film%20aesthetic&width=800&height=450&seq=article-10-b&orientation=landscape',
    ],
    updateInfo: '更新至16集 · 每周五更新2集', episodeInfo: '全36集 · HD 4K',
    relatedIds: [204, 205],
  },
  12: {
    id: 12, title: '三体：黑暗森林', subtitle: '黑暗森林法则正式揭晓，人类文明面临终极考验',
    category: '科幻 / 悬疑', tags: ['科幻', '悬疑', '太空', '文明'],
    year: '2026', region: '中国大陆', language: '普通话', duration: '50分钟/集', rating: '9.2',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    synopsis: '三体危机逐渐逼近，人类发现了宇宙社会学的黑暗森林法则。罗辑被选为面壁者，获得了几乎无限的资源来对抗三体世界。然而面壁计划遭到破壁人的致命打击，人类必须找到新的希望。与此同时，章北海在太空中做出了一个改变人类命运的选择。在这场跨越百年的博弈中，人类文明与三体文明的较量进入白热化阶段。',
    highlights: ['忠实原著：刘慈欣亲自参与改编，还原经典场景', '视效震撼：宇宙场景真实还原，黑暗森林法则视觉化', '演技炸裂：张鲁一饰演的罗辑获赞神级还原', '哲学思考：探讨人类文明在宇宙中的位置'],
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20scene%20with%20cosmic%20dark%20forest%20concept%2C%20warm%20golden%20light%20beams%20in%20darkness%2C%20mysterious%20atmosphere%2C%20dark%20space%20background%2C%20professional%20cinematic%20aesthetic&width=800&height=450&seq=article-12-hd&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Sci-fi%20scene%20with%20alien%20civilization%20signal%20visualization%2C%20warm%20golden%20and%20teal%20contrast%2C%20cinematic%20lighting%2C%20dark%20cosmic%20background%2C%20professional%20film%20aesthetic&width=800&height=450&seq=article-12-a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Futuristic%20control%20room%20with%20holographic%20displays%2C%20warm%20amber%20glow%2C%20cinematic%20composition%2C%20dark%20atmospheric%20background%2C%20professional%20scifi%20aesthetic&width=800&height=450&seq=article-12-b&orientation=landscape',
    ],
    updateInfo: '更新至8集 · 每周三更新1集', episodeInfo: '全18集 · HD 4K 杜比',
    relatedIds: [2, 6, 103],
  },
};

export function getArticleById(id: number): ArticleData | undefined {
  return articleMap[id];
}

export function getRelatedArticles(ids: number[]): ArticleData[] {
  return ids.map((id) => articleMap[id]).filter(Boolean);
}